import { createCabinAdapterV1 } from '@s7/header';
var HEADER_SERVICE_URL = process.env.REACT_APP_HEADER_SERVICE_URL;
export var adapter = createCabinAdapterV1({
    url: HEADER_SERVICE_URL,
    cache: true,
});
